import { GridColDef } from "@mui/x-data-grid";
import { renderDate } from "../../../../component/list/table-column-renders";

export const columns: GridColDef[] = [
    { field: 'day', headerName: 'Day', flex: 1, valueFormatter: (params) => { return renderDate(params.value) } },
    { field: 'startTime', headerName: 'Time', flex: 0.7, valueGetter: (params) => `${params.row.startTime} - ${params.row.endTime}` },
    { field: 'title', headerName: 'Session', flex: 1.5 },
    { field: 'guideCount', headerName: 'Guides', flex: 0.5 },
    { field: 'coachCount', headerName: 'Coaches', flex: 0.5 },
    { field: 'explorerCount', headerName: 'Explorers', flex: 0.5 }
];
